import styled from '@emotion/styled';
import StraightenIconBase from '@portalterreno/react-ui-icons/StraightenIcon';

const StraightenIcon = styled(StraightenIconBase)(
  {
    marginRight: 5,
    verticalAlign: 'bottom',
    marginBottom: -1
  },
  ({ theme }) => ({
    color: theme.palette.colors.pastelBlue
  })
);

export default StraightenIcon;
